import { render, staticRenderFns } from "./card-videos.vue?vue&type=template&id=6828cb10&scoped=true"
import script from "./card-videos.vue?vue&type=script&lang=js"
export * from "./card-videos.vue?vue&type=script&lang=js"
import style0 from "./card-videos.vue?vue&type=style&index=0&id=6828cb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828cb10",
  null
  
)

export default component.exports